<template>
  <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
    <BaseScrollbar
      class="h-fit max-h-[480px]"
      :wheel-propagation="true"
      :scroll-y-margin-offset="30">
      <div class="flex flex-col space-y-3">
        <slot :name="rtl ? 'right' : 'left'"></slot>
      </div>

      <div class="pb-5"></div>
    </BaseScrollbar>
    <BaseScrollbar
      class="flex flex-col space-y-3 h-fit max-h-[480px]"
      :wheel-propagation="true"
      :scroll-y-margin-offset="30">
      <div class="flex flex-col space-y-3">
        <slot :name="rtl ? 'left' : 'right'"></slot>
      </div>
      <div class="pb-5"></div>
    </BaseScrollbar>
  </div>
</template>

<script setup lang="ts">
import BaseScrollbar from '@/components/BaseScrollbar/BaseScrollbar.vue';

defineProps({
  rtl: {
    type: Boolean,
    default: false,
  },
});
</script>
